// ES translations for Surplify.
// Maintained as a per-language file. See ../i18n.js for init logic.

const es = {
  "app.title": "Surplify",
  "nav.home": "Inicio",
  "nav.search": "Buscar",
  "nav.watchlist": "Lista de seguimiento",
  "nav.requests": "Mis solicitudes",
  "nav.dashboard": "Panel",
  "nav.admin": "Admin",
  "nav.import": "Importar",
  "nav.login": "Iniciar sesión",
  "nav.register": "Registrarse",
  "nav.logout": "Cerrar sesión",
  "nav.groupRequests": "Solicitudes del sitio",
  "groupRequests.title": "Solicitudes entrantes del sitio",
  "groupRequests.subtitle": "Solicitudes dirigidas a los sitios de su grupo",
  "groupRequests.pending": "pendientes",
  "groupRequests.filterAll": "Todos los estados",
  "groupRequests.empty": "Sin solicitudes entrantes",
  "groupRequests.emptyHint": "Actualmente no hay solicitudes dirigidas a sus sitios.",
  "groupRequests.site": "Sitio destino",
  "material.request": "Solicitar material",
  "material.addToWatchlist": "Agregar a seguimiento",
  "material.removeFromWatchlist": "Quitar de seguimiento",
  "status.available": "Disponible",
  "status.reserved": "Reservado",
  "status.pending": "Pendiente",
  "status.approved": "Aprobado",
  "status.rejected": "Rechazado",
  "status.completed": "Completado",
  "status.documentation_missing": "Docs. faltantes",
  "badge.groupOnly": "Solo grupo",
  "badge.external": "Externo",
  "badge.slowMoving": "Rotación lenta",
  "badge.nonMoving": "Sin rotación",
  "badge.missingDocs": "Docs. faltantes",
  "filter.category": "Categoría",
  "filter.site": "Sitio",
  "filter.age": "Antigüedad",
  "filter.manufacturer": "Fabricante",
  "filter.price": "Precio",
  "filter.width": "Ancho",
  "filter.country": "País",
  "filter.allCountries": "Todos los países",
  "common.search": "Buscar materiales...",
  "common.loading": "Cargando...",
  "common.noResults": "Sin resultados",
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.submit": "Enviar",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.view": "Ver",
  "common.close": "Cerrar",
  "common.back": "Volver",
  "common.saving": "Guardando...",
  "common.create": "Crear",
  "home.newListings": "Nuevos listados",
  "home.highValue": "Alto valor",
  "home.featured": "Materiales destacados",
  "auth.email": "Correo electrónico",
  "auth.password": "Contraseña",
  "auth.name": "Nombre completo",
  "auth.loginTitle": "Iniciar sesión",
  "auth.registerTitle": "Crear cuenta",
  "auth.noAccount": "¿No tiene una cuenta?",
  "auth.hasAccount": "¿Ya tiene una cuenta?",
  "auth.registrationSuccess": "¡Registro exitoso!",
  "auth.pendingApproval": "Su cuenta ha sido creada y está esperando la aprobación del administrador.",
  "auth.registerDesc": "Cree una cuenta para comenzar a comerciar materiales",
  "dashboard.totalInventory": "Inventario total",
  "dashboard.slowMoving": "Rotación lenta (>180 días)",
  "dashboard.nonMoving": "Sin rotación (>360 días)",
  "dashboard.pendingRequests": "Solicitudes pendientes",
  "dashboard.monthlyTransfers": "Transferencias mensuales",
  "dashboard.overdueItems": "Artículos vencidos",
  "dashboard.subtitle": "Resumen global de inventario",
  "dashboard.siteFilter": "Filtrar por sitio",
  "dashboard.allSites": "Todos los sitios",
  "dashboard.slowMovingDesc": "Materiales de 181-360 días",
  "dashboard.nonMovingDesc": "Materiales de más de 360 días",
  "dashboard.transfersDesc": "Transferencias internas este mes",
  "dashboard.overdueDesc": "Artículos que requieren atención",
  "dashboard.ageChart": "Inventario por antigüedad",
  "dashboard.ageChartDesc": "Distribución del valor por antigüedad",
  "dashboard.siteRanking": "Ranking de sitios",
  "dashboard.siteRankingDesc": "Sitios con más inventario de rotación lenta",
  "dashboard.overdueTitle": "Artículos vencidos (>360 días)",
  "dashboard.overdueDesc2": "Estos artículos requieren atención inmediata",
  "dashboard.viewAllOverdue": "Ver todos los {{count}} artículos vencidos",
  "dashboard.viewNonMoving": "Ver stock sin rotación",
  "dashboard.pendingRequestsLink": "Solicitudes pendientes",
  "dashboard.importMaterials": "Importar materiales",
  "dashboard.age0_90": "0-90 días",
  "dashboard.age91_180": "91-180 días",
  "dashboard.age181_360": "181-360 días",
  "dashboard.ageGt360": ">360 días",
  "dashboard.slowMovingItems": "Artículos de rotación lenta",
  "dashboard.totalMaterials": "Total materiales",
  "dashboard.totalMaterialsDesc": "Materiales activos en inventario",
  "dashboard.externalSales": "Ventas externas",
  "dashboard.externalSalesDesc": "Ventas externas este mes",
  "dashboard.sitePending": "Solicitudes pendientes",
  "dashboard.sitePendingDesc": "Solicitudes pendientes para este sitio",
  "import.title": "Importar materiales",
  "import.subtitle": "Importar y exportar datos de materiales por Excel",
  "import.downloadTemplate": "Descargar plantilla",
  "import.uploadFile": "Subir archivo",
  "import.validate": "Validar",
  "import.execute": "Ejecutar importación",
  "import.mode.overwrite": "Sobrescribir todo",
  "import.mode.enrich": "Solo enriquecer",
  "import.mode.selective": "Seleccionar campos",
  "import.export": "Exportar",
  "import.exportTitle": "Exportar materiales",
  "import.exportDesc": "Descargar datos de materiales como archivo Excel con filtros",
  "import.exportDownload": "Descargar Excel",
  "request.title": "Solicitar material",
  "request.quantity": "Cantidad",
  "request.message": "Mensaje (opcional)",
  "request.type.internal": "Transferencia interna",
  "request.type.external": "Consulta externa",
  "requests.tab.my": "Mis solicitudes",
  "requests.tab.incoming": "Solicitudes entrantes",
  "requests.details": "Detalles de la solicitud",
  "requests.detail.article": "Artículo",
  "requests.detail.quantity": "Cantidad solicitada",
  "requests.detail.type": "Tipo",
  "requests.detail.requestedBy": "Solicitado por",
  "requests.detail.date": "Fecha",
  "requests.detail.message": "Mensaje",
  "requests.from": "De",
  "requests.viewDetails": "Ver detalles",
  "requests.loginRequired": "Inicio de sesión requerido",
  "requests.loginHint": "Inicie sesión para ver sus solicitudes",
  "requests.empty.my": "No hay solicitudes enviadas",
  "requests.empty.myHint": "Aún no ha realizado solicitudes. Explore materiales y envíe una solicitud.",
  "requests.empty.incoming": "No hay solicitudes entrantes",
  "requests.empty.incomingHint": "No tiene solicitudes entrantes para sus materiales.",
  "requests.action.approve": "Aprobar",
  "requests.action.reject": "Rechazar",
  "requests.action.complete": "Completar",
  "requests.action.approveTitle": "Aprobar solicitud",
  "requests.action.rejectTitle": "Rechazar solicitud",
  "requests.action.completeTitle": "Completar solicitud",
  "requests.action.approveDesc": "Esto aprobará la solicitud y reservará el material.",
  "requests.action.rejectDesc": "Esto rechazará la solicitud.",
  "requests.action.completeDesc": "Esto completará la transferencia y actualizará el inventario.",
  "requests.action.approvedSuccess": "Solicitud aprobada",
  "requests.action.rejectedSuccess": "Solicitud rechazada",
  "requests.action.completedSuccess": "Solicitud completada - inventario actualizado",
  "requests.action.failed": "Error al actualizar la solicitud",
  "restricted.title": "Contenido restringido",
  "restricted.loginHint": "Inicie sesión para ver precios, cantidades y ubicación.",
  "restricted.approvalHint": "Su cuenta está pendiente de aprobación.",
  "restricted.cardHint": "Inicie sesión y obtenga aprobación para ver detalles",
  "admin.users": "Usuarios",
  "admin.usersDesc": "Gestionar registros y aprobaciones de usuarios",
  "admin.noUsers": "No se encontraron usuarios",
  "admin.approved": "Aprobado",
  "admin.pending": "Pendiente",
  "admin.registeredAt": "Registrado",
  "admin.approveUser": "Aprobar",
  "admin.revokeUser": "Revocar",
  "admin.userApproved": "Usuario aprobado exitosamente",
  "admin.userRevoked": "Acceso de usuario revocado",
  "admin.userApproveFailed": "Error al actualizar estado del usuario",
  "admin.deleteUser": "Eliminar usuario",
  "admin.deleteUserTitle": "Eliminar usuario",
  "admin.deleteUserConfirm": "¿Está seguro de que desea eliminar permanentemente al usuario {{name}} ({{email}})? Esta acción no se puede deshacer.",
  "admin.userDeleted": "Usuario eliminado correctamente",
  "admin.userDeleteFailed": "Error al eliminar el usuario",
  "admin.categoryTree": "Árbol de categorías",
  "admin.categoryTreeDesc": "Gestionar categorías de productos y su jerarquía",
  "admin.addCategory": "Agregar categoría",
  "admin.editCategory": "Editar categoría",
  "admin.deleteCategory": "Eliminar categoría",
  "admin.addCategoryDesc": "Crear nueva categoría de producto",
  "admin.editCategoryDesc": "Editar nombre, categoría padre u orden",
  "admin.deleteCategoryConfirm": "¿Está seguro de eliminar \"{{name}}\"?",
  "admin.categoryName": "Nombre de categoría",
  "admin.categoryNamePlaceholder": "ej. Películas y láminas",
  "admin.parentCategory": "Categoría padre",
  "admin.noParent": "Ninguna (nivel raíz)",
  "admin.sortOrder": "Orden",
  "admin.categoryCreated": "Categoría creada",
  "admin.categoryUpdated": "Categoría actualizada",
  "admin.categoryDeleted": "Categoría desactivada",
  "admin.categoryCreateFailed": "Error al crear categoría",
  "admin.categoryUpdateFailed": "Error al actualizar categoría",
  "admin.categoryDeleteFailed": "Error al eliminar categoría",
  "admin.noCategoriesFound": "No se encontraron categorías.",
  "admin.delete": "Eliminar",
  "create.newTitle": "Publicar material",
  "create.editTitle": "Editar material",
  "create.materialInfo": "Información del material",
  "create.title": "Título",
  "create.titlePlaceholder": "ej. Película PE 500mm transparente",
  "create.description": "Descripción",
  "create.descPlaceholder": "Descripción detallada del material...",
  "create.selectCategory": "Seleccionar categoría",
  "create.companyGroup": "Grupo empresarial",
  "create.selectGroup": "Seleccionar grupo",
  "create.partNumber": "Número de pieza",
  "create.thickness": "Espesor",
  "create.grade": "Grado del material",
  "create.coreDiameter": "Diámetro del núcleo",
  "create.skuInfo": "Datos de stock (SKU)",
  "create.addSku": "Agregar stock",
  "create.addMore": "Agregar SKU",
  "create.selectSite": "Seleccionar sitio",
  "create.articleNumber": "Número de artículo",
  "create.rolls": "Número de rollos",
  "create.bookValue": "Valor contable",
  "create.listPrice": "Precio de lista",
  "create.productionDate": "Fecha de producción",
  "create.customerSpecific": "Específico del cliente",
  "create.compliant": "Conforme",
  "create.notesInternal": "Notas internas",
  "create.notesInternalPlaceholder": "Solo visible internamente...",
  "create.publish": "Publicar",
  "create.materialCreated": "Material creado exitosamente",
  "create.materialUpdated": "Material actualizado exitosamente",
  "create.existingSkus": "Stock existente",
  "create.noNewSkus": "No se agregó nuevo stock",
  "create.previewHint": "Vista previa del material",
  "create.untitled": "Material sin título",
  "create.titleRequired": "El título es obligatorio",
  "create.categoryRequired": "La categoría es obligatoria",
  "create.manufacturerRequired": "El fabricante es obligatorio",
  "create.partNumberRequired": "El número de pieza es obligatorio",
  "create.groupRequired": "El grupo empresarial es obligatorio",
  "create.siteRequired": "El sitio es obligatorio",
  "create.articleRequired": "El número de artículo es obligatorio",
  "create.quantityRequired": "La cantidad es obligatoria",
  "create.saveError": "Error al guardar el material",
  "watchlist.loginRequired": "Inicio de sesión requerido",
  "watchlist.loginHint": "Inicie sesión para ver su lista de seguimiento",
  "watchlist.empty": "Su lista de seguimiento está vacía",
  "watchlist.emptyHint": "Explore materiales y haga clic en el icono de corazón",
  "watchlist.browse": "Explorar materiales",
  "watchlist.remove": "Eliminar",
  "watchlist.priceOnRequest": "Precio a consultar",
  "watchlist.addedOn": "Agregado el",
  "watchlist.itemCount": "{{count}} artículos en su lista",
  "sustainability.title": "Impacto de sostenibilidad",
  "sustainability.subtitle": "Reducción de residuos mediante redistribución inteligente",
  "sustainability.heroTagline": "Economía circular para embalajes",
  "sustainability.heroDesc": "Cada material redistribuido es uno menos producido desde cero. Juntos reducimos CO2, ahorramos recursos y construimos un ecosistema de fabricación circular.",
  "sustainability.co2Saved": "CO2 ahorrado",
  "sustainability.co2SavedDesc": "Emisiones evitadas estimadas",
  "sustainability.materialsRedistributed": "Materiales redistribuidos",
  "sustainability.materialsRedistributedDesc": "Transferidos exitosamente entre sitios",
  "sustainability.valueSaved": "Valor preservado",
  "sustainability.valueSavedDesc": "Capital de trabajo salvado",
  "sustainability.activeSites": "Sitios activos",
  "sustainability.activeSitesDesc": "Sitios participando en redistribución",
  "sustainability.circularRate": "Tasa de economía circular",
  "sustainability.circularRateDesc": "Materiales con segunda vida",
  "sustainability.atRisk": "Materiales en riesgo",
  "sustainability.atRiskDesc": "Stock de rotación lenta/nula redistribuible",
  "sustainability.pendingRedist": "Redistribuciones pendientes",
  "sustainability.pendingRedistDesc": "Transferencias en proceso",
  "sustainability.availableForReuse": "Disponible para reutilización",
  "sustainability.impactBanner": "Juntos prevenimos residuos de embalaje y ahorramos recursos",
  "sustainability.kgUnit": "kg",
  "sustainability.tonUnit": "t",
  "sustainability.downloadReport": "Descargar informe ESG",
  "sustainability.downloadReportDesc": "Generar informe PDF de sostenibilidad",
  "sustainability.reportGenerating": "Generando informe...",
  "sustainability.reportReady": "Informe ESG descargado exitosamente",
  "sustainability.reportError": "Error al generar el informe",
  "footer.tagline": "Mercado gobernado para materiales de embalaje excedentes.",
  "footer.marketplace": "Mercado",
  "footer.forPartners": "Para socios",
  "footer.support": "Soporte",
  "footer.legalTitle": "Legal",
  "footer.agb": "Condiciones generales",
  "footer.impressum": "Aviso legal",
  "footer.datenschutz": "Política de privacidad",
  "footer.datenschutzeinstellungen": "Configuración de privacidad",
  "footer.rights": "Todos los derechos reservados.",
  "nav.standardMaterials": "Materiales estándar",
  "nav.transactions": "Transacciones",
  "nav.matching": "Material Matching",
  "nav.analytics": "Analíticas",
  "nav.language": "Idioma",
  "nav.switchGroup": "Cambiar grupo",
  "matching.title": "Material Matching",
  "matching.subtitle": "Coincidencia automática de excedentes con la demanda de otros sitios",
  "matching.refresh": "Actualizar",
  "matching.matches": "Coincidencias",
  "matching.matchRate": "Tasa de coincidencia",
  "matching.potSavings": "Ahorro pot.",
  "matching.sites": "Sitios",
  "matching.surplusAvailable": "{{count}} excedentes disponibles",
  "matching.demandPositions": "{{count}} posiciones de demanda",
  "matching.matchedQuantity": "{{count}} kg cantidad coincidente",
  "matching.providers": "{{count}} proveedores",
  "matching.consumers": "{{count}} consumidores",
  "matching.topMaterials": "Materiales más coincidentes",
  "matching.offerSite": "Sitio proveedor",
  "matching.demandSite": "Sitio demandante",
  "matching.manufacturer": "Fabricante",
  "matching.searchManufacturer": "Buscar fabricante...",
  "matching.allSites": "Todos los sitios",
  "matching.noMatches": "Sin coincidencias",
  "matching.noMatchesDesc": "No se encontraron coincidencias entre excedentes y listas de demanda.",
  "matching.matchesFound": "{{count}} coincidencia(s) encontrada(s)",
  "matching.material": "Material",
  "matching.provider": "Proveedor",
  "matching.consumer": "Consumidor",
  "matching.quantity": "Cantidad",
  "matching.bookValue": "Valor contable",
  "matching.age": "Antigüedad",
  "matching.width": "Ancho",
  "matching.widthFit": "Encaja",
  "matching.widthDeviation": "Desv.",
  "matching.action": "Acción",
  "matching.view": "Ver",
  "matching.age0_90": "0–90 días",
  "matching.age91_180": "91–180 días",
  "matching.age181_360": "181–360 días",
  "matching.ageGt360": "> 360 días",
  "analytics.title": "Analíticas e informes",
  "analytics.subtitle": "Análisis de tendencias, rendimiento de sitios y evaluaciones de coincidencias",
  "analytics.tabTrends": "Tendencias",
  "analytics.tabSites": "Sitios",
  "analytics.tabMatching": "Matching",
  "analytics.last6Months": "Últimos 6 meses",
  "analytics.last12Months": "Últimos 12 meses",
  "analytics.last24Months": "Últimos 24 meses",
  "analytics.inventoryTrend": "Evolución del inventario",
  "analytics.inventoryTrendDesc": "Desarrollo mensual de artículos y valor de inventario",
  "analytics.articles": "Artículos",
  "analytics.valueKEUR": "Valor (kEUR)",
  "analytics.transactionVolume": "Volumen de transacciones",
  "analytics.transactionVolumeDesc": "Transacciones mensuales",
  "analytics.transactions": "Transacciones",
  "analytics.requestTrend": "Evolución de solicitudes",
  "analytics.requestTrendDesc": "Total vs. solicitudes completadas",
  "analytics.requests": "Solicitudes",
  "analytics.completed": "Completadas",
  "analytics.siteComparison": "Comparación de sitios: valor de inventario",
  "analytics.siteComparisonDesc": "Valor total (kEUR) por sitio",
  "analytics.redistributionRanking": "Ranking de redistribución",
  "analytics.redistributionRankingDesc": "Redistribuciones completadas por sitio",
  "analytics.redistributions": "Redistribuciones",
  "analytics.openRequests": "Solicitudes abiertas",
  "analytics.siteDetails": "Detalles del sitio",
  "analytics.site": "Sitio",
  "analytics.value": "Valor (kEUR)",
  "analytics.slowMoving": "Rotación lenta",
  "analytics.redistributed": "Redistribuido",
  "analytics.demand": "Demanda",
  "analytics.noSiteData": "No hay datos de sitio disponibles",
  "analytics.kpiMatches": "Coincidencias",
  "analytics.kpiMatchRate": "Tasa de coincidencia",
  "analytics.kpiMatchedValue": "Valor coincidente",
  "analytics.kpiMaterials": "Materiales",
  "analytics.topMatchedMaterials": "Materiales más coincidentes",
  "analytics.categoryDistribution": "Coincidencias por categoría",
  "analytics.sitePairFlows": "Flujos de sitio (Proveedor → Consumidor)",
  "analytics.sitePairFlowsDesc": "Flujos de material más frecuentes entre sitios",
  "analytics.noData": "Sin datos",
  "analytics.noMatchingData": "Sin datos de coincidencia disponibles",
  "transactions.title": "Transacciones",
  "transactions.subtitle": "Todas las transacciones completadas y abiertas",
  "transactions.allStatuses": "Todos los estados",
  "transactions.statusCompleted": "Completada",
  "transactions.statusCancelled": "Cancelada",
  "transactions.statusPending": "Abierta",
  "transactions.total": "Transacciones",
  "transactions.completed": "Completadas",
  "transactions.totalValue": "Valor total",
  "transactions.date": "Fecha",
  "transactions.material": "Material",
  "transactions.type": "Tipo",
  "transactions.seller": "Vendedor",
  "transactions.buyer": "Comprador",
  "transactions.quantity": "Cantidad",
  "transactions.value": "Valor",
  "transactions.fee": "Tarifa",
  "transactions.status": "Estado",
  "transactions.rating": "Valoración",
  "transactions.internal": "Interno",
  "transactions.external": "Externo",
  "transactions.empty": "Aún no hay transacciones",
  "transactions.emptyDesc": "Las transacciones se crean automáticamente al completar solicitudes.",
  "transactions.rate": "Valorar",
  "transactions.rated": "Valorada",
  "transactions.rateTitle": "Valorar transacción",
  "transactions.counterparty": "Contraparte",
  "transactions.unknown": "Desconocido",
  "transactions.commentLabel": "Comentario (opcional)",
  "transactions.commentPlaceholder": "¿Cómo fue la cooperación?",
  "transactions.submitRating": "Enviar valoración",
  "transactions.submitting": "Enviando...",
  "transactions.ratingSuccess": "Valoración enviada",
  "transactions.ratingError": "Error al enviar valoración",
  "transactions.ratingRequired": "Valore al menos una categoría",
  "transactions.loadError": "Error al cargar transacciones",
  "transactions.reviews": "Valoraciones",
  "transactions.noReviews": "Aún no hay valoraciones.",
  "transactions.comments": "Comentarios",
  "transactions.group": "Grupo",
  "transactions.review": "valoraciones",
  "notifications.title": "Notificaciones",
  "notifications.allRead": "Todas leídas",
  "notifications.none": "Sin notificaciones",
  "notifications.noFiltered": "Sin notificaciones coincidentes",
  "notifications.filterAll": "Todas",
  "notifications.filterMatches": "Coincidencias",
  "notifications.filterOther": "Otras",
  "notifications.newMatch": "{{count}} nueva coincidencia de material",
  "notifications.newMatches": "{{count}} nuevas coincidencias de material",
  "notifications.goToDashboard": "Ir al panel",
  "notifications.matchDashboard": "Mostrar panel de Material Matching",
  "notifications.justNow": "ahora mismo",
  "notifications.minutesAgo": "hace {{count}} min",
  "notifications.hoursAgo": "hace {{count}} h",
  "notifications.daysAgo": "hace {{count}} d",
  "notifications.site": "Sitio",
  "notifications.typeMatch": "Coincidencia",
  "notifications.typeApproval": "Coincidencia aprobación",
  "notifications.typeRequest": "Solicitud",
  "notifications.typeEscalation": "Escalación",
  "notifications.typeLogistics": "Logística",
  "notifications.typeInfo": "Info",
  "partners.heroTitle": "Comprar. Vender. Reutilizar. Materiales excedentes — más inteligente.",
  "partners.heroSubtitle": "Únase al mercado líder de excedentes de envases. Acceda a materiales verificados de los principales fabricantes y ahorre hasta un 40% en costes de adquisición.",
  "partners.ctaRegister": "Registrarse como socio",
  "partners.ctaBrowse": "Explorar materiales",
  "partners.trust1": "Registro gratuito",
  "partners.trust2": "Proveedores verificados",
  "partners.trust3": "Sin compromiso",
  "partners.howItWorksLabel": "Proceso",
  "partners.howItWorksTitle": "Cómo funciona",
  "partners.howItWorksSubtitle": "Tres sencillos pasos para empezar a ahorrar.",
  "partners.step1Title": "Registrarse",
  "partners.step1Desc": "Cree su cuenta empresarial en minutos. Nuestro equipo verificará su empresa y activará su acceso.",
  "partners.step2Title": "Explorar",
  "partners.step2Desc": "Busque miles de materiales excedentes verificados de fabricantes de envases. Filtre por tipo, cantidad y ubicación.",
  "partners.step3Title": "Solicitar",
  "partners.step3Desc": "Envíe una solicitud directamente al proveedor. La plataforma gestiona todo el proceso.",
  "partners.benefitsTitle": "Por qué elegir Surplify",
  "partners.benefit1Title": "Ahorre hasta el 40%",
  "partners.benefit1Desc": "Acceda a materiales excedentes a una fracción del coste original.",
  "partners.benefit2Title": "Calidad verificada",
  "partners.benefit2Desc": "Cada anuncio incluye datos del fabricante, especificaciones e informes de estado.",
  "partners.benefit3Title": "Impacto ESG",
  "partners.benefit3Desc": "Cada compra reduce las emisiones de CO2. Trazabilidad completa para su informe de sostenibilidad.",
  "partners.trustTitle": "Confiado por líderes del sector",
  "partners.trustSubtitle": "Empresas de toda Europa ya confían en Surplify",
  "partners.trustUsers": "50+ empresas",
  "partners.trustStat1": "40%",
  "partners.trustStat1Label": "Ahorro medio en costes",
  "partners.trustStat2": "500+",
  "partners.trustStat2Label": "Anuncios verificados",
  "partners.trustStat3": "50+",
  "partners.trustStat3Label": "Empresas socias activas",
  "partners.ctaFinalTitle": "¿Listo para empezar a ahorrar?",
  "partners.ctaFinalDesc": "Únase a cientos de empresas que ya usan Surplify para reducir costes y cumplir objetivos ESG.",
  "partners.ctaFinalRegister": "Empezar gratis",
  "partners.noCredit": "Sin tarjeta de crédito. Registro gratuito.",
  "demo.badge": "Reservar demo",
  "demo.ctaHero": "Reservar demo",
  "demo.title": "Vea Surplify en acción",
  "demo.subtitle": "Reserve una demo gratuita y personalizada con nuestro equipo.",
  "demo.point1": "Recorrido en vivo por la plataforma",
  "demo.point2": "Adaptado a su industria y necesidades",
  "demo.point3": "Sin compromiso — completamente gratis",
  "demo.name": "Nombre",
  "demo.namePlaceholder": "Su nombre completo",
  "demo.email": "Correo empresarial",
  "demo.emailPlaceholder": "nombre@empresa.com",
  "demo.company": "Empresa",
  "demo.companyPlaceholder": "Nombre de su empresa",
  "demo.phone": "Teléfono (opcional)",
  "demo.phonePlaceholder": "+34 ...",
  "demo.message": "Mensaje (opcional)",
  "demo.messagePlaceholder": "Cuéntenos sobre sus necesidades...",
  "demo.submit": "Solicitar demo",
  "demo.sending": "Enviando...",
  "demo.privacy": "Respetamos su privacidad. Sus datos solo se usarán para contactarle sobre su solicitud de demo.",
  "demo.requiredFields": "Por favor complete todos los campos obligatorios.",
  "demo.successToast": "Solicitud de demo enviada con éxito.",
  "demo.errorToast": "Error al enviar la solicitud. Inténtelo de nuevo.",
  "demo.successTitle": "¡Gracias!",
  "demo.successDesc": "Hemos recibido su solicitud. Nuestro equipo se pondrá en contacto en 24 horas.",
  "onboarding.step": "Paso",
  "onboarding.of": "de",
  "onboarding.skip": "Omitir por ahora",
  "onboarding.next": "Siguiente",
  "onboarding.finish": "Empezar",
  "onboarding.restartTour": "Reiniciar el tour",
  "onboarding.step1Title": "Bienvenido a Surplify",
  "onboarding.step1Desc": "Surplify es el mercado líder de excedentes de envases. Encuentre, solicite y negocie materiales verificados.",
  "onboarding.step1Points": ["Miles de materiales verificados", "Ahorre hasta un 40%", "Seguimiento automático del impacto ESG"],
  "onboarding.step2Title": "Su perfil empresarial",
  "onboarding.step2Desc": "Su perfil representa a su empresa en la plataforma. Un perfil completo genera más confianza.",
  "onboarding.step2Points": ["Añada logo y descripción", "Verifique sus datos de contacto", "Configure preferencias de materiales"],
  "onboarding.step3Title": "Encontrar materiales",
  "onboarding.step3Desc": "Use la búsqueda avanzada para encontrar exactamente lo que necesita.",
  "onboarding.step3Points": ["Busque por fabricante o número de artículo", "Filtre por categoría, país y cantidad", "Guarde materiales en su lista de seguimiento"],
  "onboarding.step4Title": "Solicitar materiales",
  "onboarding.step4Desc": "¿Encontró lo que necesita? Envíe una solicitud directamente al proveedor.",
  "onboarding.step4Points": ["Indique la cantidad requerida", "Añada un mensaje al proveedor", "Siga el estado en tiempo real"],
  "admin.addCompany": "Agregar empresa",
  "admin.addGroup": "Agregar grupo",
  "admin.addSite": "Agregar sitio",
  "admin.approvalRequired": "Aprobacion requerida",
  "admin.approvalRequiredDesc": "Requiere aprobacion del gerente para solicitudes",
  "admin.approve": "Aprobar",
  "admin.approveCompany": "Aprobar",
  "admin.auditAction": "Accion",
  "admin.auditAll": "Todos",
  "admin.auditChanges": "Cambios",
  "admin.auditEntity": "Entidad",
  "admin.auditFilterAction": "Filtrar por accion",
  "admin.auditFilterEntity": "Filtrar por entidad",
  "admin.auditLog": "Registro de auditoria",
  "admin.auditLogDesc": "Historial completo de todos los cambios del sistema",
  "admin.auditNextPage": "Siguiente",
  "admin.auditNoEntries": "No se encontraron entradas de auditoria.",
  "admin.auditPage": "Pagina {{page}} de {{pages}}",
  "admin.auditPrevPage": "Anterior",
  "admin.auditTimestamp": "Marca de tiempo",
  "admin.auditUser": "Usuario",
  "admin.autoApproval": "Aprobacion automatica",
  "admin.categories": "Categorias",
  "admin.city": "Ciudad",
  "admin.companyApproved": "Empresa aprobada",
  "admin.companyCreated": "Empresa creada exitosamente",
  "admin.companyFailed": "Error al actualizar la empresa",
  "admin.companyName": "Nombre de la empresa",
  "admin.companyNamePlaceholder": "ej. PackPro GmbH",
  "admin.companyRejected": "Empresa rechazada",
  "admin.contactEmail": "Correo de contacto",
  "admin.contactName": "Nombre de contacto",
  "admin.contactPhone": "Telefono de contacto",
  "admin.country": "Pais",
  "admin.defaultImage": "Imagen predeterminada",
  "admin.docsBlocked": "Docs bloqueados",
  "admin.domainsAllowed": "Dominios permitidos",
  "admin.emailsFailed": "Correos fallidos",
  "admin.emailsSent": "Correos enviados",
  "admin.emailsSkipped": "Omitidos",
  "admin.escalatedRequests": "Solicitudes escaladas",
  "admin.escalationDays": "Dias de escalacion",
  "admin.escalationDaysDesc": "Dias antes de notificaciones de escalacion",
  "admin.externalBlocked": "Externo bloqueado",
  "admin.externalCompanies": "Empresas externas",
  "admin.externalCompaniesDesc": "Gestionar registros y aprobaciones de empresas externas",
  "admin.externalEnabled": "Publicacion externa habilitada",
  "admin.externalEnabledDesc": "Permitir que los materiales sean visibles externamente",
  "admin.externalOpen": "Externo abierto",
  "admin.groupAdmin": "Admin de grupo",
  "admin.groupAdminDesc": "Gestionar estrategia y usuarios de su grupo empresarial",
  "admin.groupName": "Nombre del grupo",
  "admin.groupNamePlaceholder": "ej. Acme Packaging Group",
  "admin.groupUsersDesc": "Gestionar y aprobar usuarios dentro de su grupo empresarial",
  "admin.guide": "Guia",
  "admin.guideAudit": "Registro de auditoria",
  "admin.guideAuditText": "El registro de auditoria proporciona un historial completo de todos los cambios del sistema para cumplimiento y trazabilidad. Cada accion se registra con usuario, marca de tiempo, tipo de entidad y datos de cambio detallados.",
  "admin.guideAuditTip": "El registro de auditoria es inmutable y no se puede editar ni eliminar. Uselo para auditorias de cumplimiento y resolucion de problemas.",
  "admin.guideCategories": "Gestion de categorias",
  "admin.guideCategoriesText": "Las categorias organizan los materiales en una estructura de arbol jerarquica. Impulsan la navegacion lateral del mercado y ayudan a los usuarios a buscar materiales por tipo.",
  "admin.guideCategoriesTip": "Las categorias eliminadas se desactivan (borrado suave). Los materiales asignados anteriormente siguen siendo accesibles.",
  "admin.guideDashboard": "Dashboard y Reporting",
  "admin.guideDashboardText": "El Dashboard ofrece KPIs en tiempo real sobre antigüedad del inventario, actividad de transferencias, metricas de sostenibilidad y valor en riesgo. Los gerentes de sitio pueden filtrar por sitio y generar informes PDF.",
  "admin.guideDashboardTip": "El informe de sostenibilidad incluye estimaciones de ahorro de CO2 basadas en las cantidades de material redistribuido.",
  "admin.guideDesc": "Guia completa para configuracion de la plataforma, gobernanza y gestion diaria",
  "admin.guideExternal": "Empresas externas",
  "admin.guideExternalText": "Las empresas externas pueden autoregistrarse en la plataforma. Los administradores revisan solicitudes y las aprueban o rechazan. Al aprobar, se crean automaticamente un grupo empresarial y un sitio, y los usuarios externos obtienen acceso al mercado.",
  "admin.guideExternalTip": "Al aprobar o rechazar, se envia automaticamente una notificacion por correo al contacto de la empresa y usuarios vinculados.",
  "admin.guideGettingStarted": "Primeros pasos",
  "admin.guideGettingStartedText": "Bienvenido a Surplify! Esta plataforma ayuda a su organizacion a reducir el capital de trabajo redistribuyendo materias primas de lenta y nula rotacion entre sitios. Tras la configuracion inicial, sus equipos pueden listar materiales excedentes, buscar articulos necesarios y transferir inventario entre sitios o socios externos.",
  "admin.guideGettingStartedTip": "Use el boton 'Cargar datos de ejemplo' para poblar categorias, materiales de ejemplo y traducciones para una demo rapida.",
  "admin.guideImport": "Importacion/Exportacion Excel",
  "admin.guideImportText": "La pagina de importacion soporta gestion masiva de materiales mediante carga de archivos Excel. Puede descargar una plantilla, llenar sus datos, validarlos y ejecutar la importacion.",
  "admin.guideImportTip": "Use el modo 'Solo enriquecer' para actualizaciones incrementales sin sobrescribir datos existentes.",
  "admin.guideNotifications": "Notificaciones por correo",
  "admin.guideNotificationsText": "La plataforma envia notificaciones automaticas por correo para solicitudes escaladas, nuevas solicitudes de material y cambios de estado de empresas externas. Todo el historial de notificaciones se registra y es visible en Admin > Notificaciones.",
  "admin.guideNotificationsTip": "Los correos de escalacion se activan cuando las solicitudes pendientes superan el umbral de 'Dias de escalacion' configurado en los ajustes del escenario.",
  "admin.guideScenarios": "Configuracion de escenarios",
  "admin.guideScenariosText": "Los escenarios controlan las reglas de gobernanza para la redistribucion de materiales. Cada modo ajusta ventanas de visibilidad, umbrales de escalacion, acceso externo y requisitos de aprobacion.",
  "admin.guideScenariosTip": "El dashboard de impacto del escenario muestra efectos en tiempo real de sus ajustes actuales, incluyendo solicitudes escaladas y articulos bloqueados.",
  "admin.guideTitle": "Guia de administracion",
  "admin.guideVotes.title": "Secciones de la guia peor valoradas",
  "admin.guideVotes.desc": "Las 5 secciones con la valoracion mas negativa de los usuarios; conviene revisarlas.",
  "admin.guideVotes.empty": "Aun no hay valoraciones.",
  "admin.guideVotes.loading": "Cargando valoraciones…",
  "admin.guideVotes.unknownSection": "Seccion desconocida",
  "admin.guideVotes.score": "Puntuacion neta (me gusta − no me gusta)",
  "admin.guideUsers": "Gestion de usuarios",
  "admin.guideUsersText": "Los usuarios se registran a traves de la plataforma y deben ser aprobados antes de acceder a datos sensibles como precios, cantidades y ubicaciones. Los administradores pueden gestionar aprobaciones y revocar acceso en cualquier momento.",
  "admin.guideUsersTip": "Revocar un usuario no elimina su cuenta. Puede ser re-aprobado en cualquier momento.",
  "admin.houseNumber": "Numero",
  "admin.industry": "Industria",
  "admin.internalWindow": "Ventana interna (dias)",
  "admin.internalWindowDesc": "Dias que los articulos son visibles solo internamente",
  "admin.internalWindowItems": "En ventana interna",
  "admin.lastCheck": "Ultima verificacion",
  "admin.legalPageContent": "Contenido de la pagina (HTML)",
  "admin.legalPageTitle": "Titulo de la pagina",
  "admin.legalPages": "Paginas legales",
  "admin.legalPagesDesc": "Editar paginas de soporte, terminos, aviso legal, privacidad y configuracion de privacidad",
  "admin.legalPreview": "Vista previa",
  "admin.loadSettings": "Cargar ajustes",
  "admin.manualApproval": "Aprobacion manual",
  "admin.masterData": "Datos maestros",
  "admin.materialApprovals": "Aprobaciones de material",
  "admin.materialApprovalsDesc": "Revisar y aprobar listados de materiales externos",
  "admin.mode.aggressive_cash": "Agresivo (Cash)",
  "admin.mode.aggressive_cashDesc": "Ventanas mas cortas, liquidacion mas rapida",
  "admin.mode.balanced": "Equilibrado",
  "admin.mode.balancedDesc": "Reglas de gobernanza estandar",
  "admin.mode.conservative": "Conservador",
  "admin.mode.conservativeDesc": "Ventanas mas largas, mas aprobaciones",
  "admin.mode.crisis_mode": "Modo crisis",
  "admin.mode.crisis_modeDesc": "Modo de eliminacion de emergencia",
  "admin.ndaNotSigned": "NDA pendiente",
  "admin.ndaSigned": "NDA firmado",
  "admin.noCompanies": "Aun no hay empresas externas registradas.",
  "admin.noGroups": "No se encontraron grupos. Agregue su primer grupo empresarial.",
  "admin.noNotifications": "Aun no se han enviado notificaciones",
  "admin.noPendingMaterials": "No hay aprobaciones de material pendientes",
  "admin.noSites": "No se encontraron sitios. Agregue su primera ubicacion.",
  "admin.noSitesNoGroup": "Cree primero un grupo empresarial antes de agregar sitios.",
  "admin.notifDaysPending": "Dias pendientes",
  "admin.notifExtApproved": "Aprobado",
  "admin.notifExtCompany": "Empresa externa",
  "admin.notifExtRejected": "Rechazado",
  "admin.notifMaterial": "Material",
  "admin.notifOwner": "Propietario",
  "admin.notifRecipients": "Destinatarios",
  "admin.notifRequestedQty": "Cantidad solicitada",
  "admin.notifRequester": "Solicitante",
  "admin.notifSentAt": "Enviado el",
  "admin.notifSite": "Sitio",
  "admin.notifStatus": "Estado",
  "admin.notifTypeEscalation": "Escalacion",
  "admin.notifTypeExtCompany": "Emp. externas",
  "admin.notifTypeNewRequest": "Nueva solicitud",
  "admin.notifications": "Notificaciones",
  "admin.notificationsDesc": "Historial de correos de escalacion y gestion",
  "admin.notificationsTitle": "Notificaciones por correo",
  "admin.orgDesc": "Gestionar organizaciones inquilinas",
  "admin.orgTitle": "Grupos empresariales",
  "admin.organizations": "Organizaciones",
  "admin.platformAdminDesc": "Administracion de plataforma - gestionar todos los grupos, sitios y usuarios",
  "admin.postalCode": "Codigo postal",
  "admin.reject": "Rechazar",
  "admin.rejectCompany": "Rechazar",
  "admin.saveSettings": "Guardar ajustes",
  "admin.scenarioImpact": "Impacto del escenario",
  "admin.scenarioImpactDesc": "Impacto en tiempo real de los ajustes actuales",
  "admin.scenarioMode": "Modo de escenario",
  "admin.scenarios": "Escenarios",
  "admin.scenariosDesc": "Configurar reglas de gobernanza y flujos de aprobacion",
  "admin.scenariosTitle": "Configuracion de escenarios",
  "admin.seedData": "Cargar datos de ejemplo",
  "admin.selectGroup": "Seleccionar grupo empresarial",
  "admin.selectGroupPlaceholder": "Elegir un grupo...",
  "admin.settingsFailed": "Error al guardar los ajustes",
  "admin.settingsSaved": "Ajustes guardados exitosamente",
  "admin.sites": "Sitios",
  "admin.sitesDesc": "Gestionar ubicaciones de almacen",
  "admin.sitesTitle": "Sitios",
  "admin.street": "Calle",
  "admin.strictDocs": "Documentacion estricta",
  "admin.strictDocsActive": "Documentacion estricta activa",
  "admin.strictDocsDesc": "Bloquear importaciones sin hojas de especificaciones",
  "admin.submittedBy": "Enviado por",
  "admin.title": "Administracion",
  "admin.totalNotifications": "Total de notificaciones",
  "admin.triggerCheck": "Verificar ahora",
  "admin.triggerCheckDesc": "Verificar manualmente solicitudes escaladas y enviar notificaciones",
  "admin.triggerCheckFailed": "Verificacion de escalacion fallida",
  "admin.triggerCheckSuccess": "Verificacion de escalacion completada",
  "admin.uploadDefaultImage": "Subir imagen",
  "admin.vatId": "ID de IVA",
  "admin.website": "Sitio web",
  "auth.companyGroup": "Grupo empresarial",
  "auth.selectCompanyGroup": "Seleccione su grupo empresarial...",
  "auth.selectSite": "Seleccione su planta...",
  "auth.site": "Planta / Sitio",
  "bulk.browse": "Examinar archivos",
  "bulk.col.article_number": "No. de articulo",
  "bulk.col.manufacturer_name": "Fabricante",
  "bulk.col.manufacturer_part_number": "Numero de pieza",
  "bulk.col.notes_internal": "Notas",
  "bulk.col.number_of_rolls": "Rollos",
  "bulk.col.quantity": "Cantidad",
  "bulk.col.uom": "UdM",
  "bulk.created": "Creados",
  "bulk.downloadTemplate": "Descargar plantilla",
  "bulk.dropHint": "Arrastre y suelte su archivo Excel/CSV aqui",
  "bulk.duplicates": "Existente (Actualizar)",
  "bulk.enriched": "Enriquecidos",
  "bulk.errors": "Errores",
  "bulk.executeImport": "Importar {{count}} filas",
  "bulk.importComplete": "Importacion completada!",
  "bulk.importError": "Importacion fallida",
  "bulk.importMode": "Modo de importacion para duplicados",
  "bulk.importMore": "Importar mas",
  "bulk.importing": "Importando...",
  "bulk.invalidFile": "Formato de archivo invalido. Use .xlsx, .xls o .csv",
  "bulk.modeEnrich": "Enriquecer",
  "bulk.modeEnrichDesc": "Solo llenar campos vacios, mantener existentes",
  "bulk.modeOverwrite": "Sobrescribir",
  "bulk.modeOverwriteDesc": "Reemplazar todos los campos con valores importados",
  "bulk.moreRows": "mas filas",
  "bulk.newItems": "Nuevos articulos",
  "bulk.parseError": "Error al analizar el archivo",
  "bulk.rejected": "Rechazados",
  "bulk.rowError": "Fila {{row}}",
  "bulk.rows": "Filas",
  "bulk.rowsLoaded": "{{count}} filas cargadas",
  "bulk.subtitle": "Importar multiples materiales a la vez via Excel/CSV",
  "bulk.templateDownloaded": "Plantilla descargada",
  "bulk.templateError": "Error al descargar la plantilla",
  "bulk.title": "Carga masiva",
  "bulk.updated": "Actualizados",
  "bulk.valid": "Valido",
  "bulk.validate": "Validar datos",
  "bulk.validateError": "Validacion fallida",
  "bulk.validating": "Validando...",
  "bulk.validationErrors": "Errores de validacion",
  "common.deleting": "Eliminando...",
  "create.addDocument": "Agregar documento PDF",
  "create.techSpec": "Ficha técnica",
  "create.techSpecHint": "Se requiere al menos una ficha técnica (PDF). Los compradores la necesitan para evaluar el material.",
  "create.techSpecRequired": "Obligatorio",
  "create.addTechSpec": "Subir ficha técnica (PDF)",
  "create.techSpecRequiredError": "Por favor, suba una ficha técnica (PDF) antes de guardar.",
  "create.addPhoto": "Foto",
  "create.documents": "Documentos (PDF)",
  "create.erpArticleNumber": "Numero de articulo ERP",
  "create.materialIndex": "Indice de material",
  "create.photos": "Fotos",
  "dashboard.agingAutoCalculated": "La antiguedad se calcula automaticamente desde la fecha de produccion",
  "dashboard.categoryBreakdown": "Desglose por categoria",
  "dashboard.categoryBreakdownDesc": "Principales categorias por valor en riesgo",
  "dashboard.items": "Articulos",
  "dashboard.kEUR": "kEUR",
  "dashboard.skus": "SKUs",
  "dashboard.topRisk": "Materiales de mayor riesgo",
  "dashboard.topRiskDesc": "Materiales de mayor valor (rotacion lenta/nula)",
  "dashboard.totalValue": "Valor total del inventario",
  "dashboard.totalValueDesc": "Valor contable total de todos los SKUs activos",
  "dashboard.valueAtRisk": "Valor en riesgo",
  "dashboard.valueAtRiskDesc": "Valor contable del stock de rotacion lenta/nula",
  "ext.alreadyRegistered": "Ya registrado?",
  "ext.backStep": "Atras",
  "ext.chooseRegistrationType": "Como desea registrarse?",
  "ext.companyInfo": "Datos de la empresa",
  "ext.confirmPassword": "Confirmar contrasena",
  "ext.continue": "Continuar",
  "ext.createFirstListing": "Listar primer material",
  "ext.createListing": "Listar material",
  "ext.deleteConfirmDesc": "Esta seguro de que desea eliminar este material? Esta accion no se puede deshacer.",
  "ext.deleteConfirmTitle": "Eliminar material?",
  "ext.fillRequired": "Por favor complete todos los campos obligatorios",
  "ext.groupName": "Nombre del grupo",
  "ext.internalUser": "Usuario interno?",
  "ext.linkedUsers": "Usuarios vinculados",
  "ext.materialDeleted": "Material eliminado",
  "ext.myCompany": "Mi empresa",
  "ext.myListings": "Mis listados",
  "ext.nextStep": "Siguiente: Cuenta de usuario",
  "ext.noCompanyLinked": "Ninguna empresa externa vinculada a su cuenta",
  "ext.noLinkedUsers": "Sin usuarios vinculados",
  "ext.noListings": "Aun no hay materiales listados",
  "ext.noListingsDesc": "Liste su primer material para ofrecerlo en el mercado.",
  "ext.passwordMismatch": "Las contrasenas no coinciden",
  "ext.passwordTooShort": "La contrasena debe tener al menos 6 caracteres",
  "ext.pendingMessage": "Su registro esta siendo revisado. Una vez aprobado, podra ofrecer materiales en el mercado.",
  "ext.pendingTitle": "Aprobacion pendiente",
  "ext.portalTitle": "Portal de empresa",
  "ext.registerAsExternal": "Registrarse como empresa externa",
  "ext.registerAsGroup": "Como grupo",
  "ext.registerAsGroupDesc": "Empresa con multiples plantas/ubicaciones",
  "ext.registerAsSite": "Como sitio individual",
  "ext.registerAsSiteDesc": "Ubicacion individual sin grupo padre",
  "ext.registerDesc": "Registre su empresa para ofrecer materiales en el mercado.",
  "ext.registerGroupDesc": "Registre su grupo para participar en el mercado con multiples sitios.",
  "ext.registerInternal": "Registrarse aqui",
  "ext.registerSiteDesc": "Registre su sitio como ubicacion individual en el mercado.",
  "ext.registerTitle": "Registrarse como empresa externa",
  "ext.registrationPending": "Su empresa esta siendo revisada. Se le notificara cuando su acceso sea activado.",
  "ext.registrationSuccess": "Registro exitoso!",
  "ext.registrationType": "Tipo",
  "ext.rejectedMessage": "Lamentablemente su registro fue rechazado. Contacte al soporte para mas informacion.",
  "ext.rejectedTitle": "Registro rechazado",
  "ext.siteName": "Nombre del sitio",
  "ext.submitRegistration": "Enviar registro",
  "ext.userAccount": "Cuenta de usuario",
  "filter.advancedFilters": "Filtros avanzados",
  "filter.ageBucket": "Antiguedad del stock",
  "filter.age_0_90": "< 3 meses",
  "filter.age_181_360": "6-12 meses",
  "filter.age_91_180": "3-6 meses",
  "filter.age_gt_360": "> 12 meses",
  "filter.basicFilters": "Filtros",
  "filter.both": "Ambos",
  "filter.certifications": "Certificaciones",
  "filter.clearAll": "Borrar todo",
  "filter.clearAllFilters": "Borrar todos los filtros",
  "filter.clearFilters": "Borrar filtros",
  "filter.complianceFlag": "Indicador de cumplimiento",
  "filter.compliant": "Conforme",
  "filter.core": "Nucleo",
  "filter.coreDiameter": "Diametro del nucleo",
  "filter.customerSpecific": "Especifico del cliente",
  "filter.filters": "Filtros",
  "filter.materialProperties": "Propiedades del material",
  "filter.max": "Max",
  "filter.min": "Min",
  "filter.minQuantity": "Cantidad minima",
  "filter.no": "No",
  "filter.qty": "Cant.",
  "filter.quantity": "Cantidad",
  "filter.stockDetails": "Detalles de stock",
  "filter.technicalSpecs": "Especificaciones tecnicas",
  "filter.thickness": "Espesor",
  "filter.thicknessRange": "Rango de espesor",
  "filter.widthRange": "Rango de ancho",
  "filter.yes": "Si",
  "group.allSites": "Todos los sitios",
  "group.filterSite": "Filtrar por sitio",
  "group.filterStatus": "Filtrar por estado",
  "group.noMaterials": "No se encontraron materiales en su grupo",
  "group.otherSite": "Otro sitio",
  "group.ownMaterial": "Material propio",
  "group.sites": "Sitios",
  "group.skuCount": "{{count}} SKUs",
  "group.subtitle": "Todos los materiales en todos los sitios de su grupo empresarial",
  "group.title": "Materiales de mi grupo",
  "group.totalValue": "Valor total",
  "masterData.applied": "Datos maestros aplicados",
  "masterData.appliedLabel": "Datos maestros aplicados",
  "masterData.matchesFound": "Datos maestros encontrados",
  "masterData.searchPlaceholder": "Buscar por proveedor, no. de articulo...",
  "myMaterials.allStatuses": "Todos los estados",
  "myMaterials.archive": "Archivar",
  "myMaterials.archiveDesc": "El material sera archivado y ya no sera visible en el mercado.",
  "myMaterials.archiveTitle": "Archivar material?",
  "myMaterials.archived": "Material archivado",
  "myMaterials.articles": "articulos",
  "myMaterials.bulkUpload": "Carga masiva",
  "myMaterials.deleteDesc": "El material y todo el inventario asociado se eliminaran permanentemente.",
  "myMaterials.deleteTitle": "Eliminar material?",
  "myMaterials.deleted": "Material eliminado",
  "myMaterials.empty": "No se encontraron articulos",
  "myMaterials.emptyDesc": "Aun no se han publicado articulos en su sitio.",
  "myMaterials.newArticle": "Nuevo articulo",
  "myMaterials.noSite": "Su cuenta no tiene un sitio asignado.",
  "myMaterials.noSiteDesc": "Contacte a un administrador para ser asignado a un sitio.",
  "myMaterials.noSiteTitle": "Sin sitio asignado",
  "myMaterials.quantity": "Cant.",
  "myMaterials.searchPlaceholder": "Buscar articulos...",
  "myMaterials.statusArchived": "Archivado",
  "myMaterials.title": "Mis materiales del sitio",
  "myMaterials.value": "Valor",
  "myMaterials.you": "Usted",
  "nav.myGroup": "Mi grupo",
  "nav.myMaterials": "Mis articulos",
  "nav.scenario": "Escenario",
  "pagination.next": "Siguiente",
  "pagination.previous": "Anterior",
  "preset.applied": "Preajuste \"{name}\" aplicado",
  "preset.applyFailed": "Error al aplicar el preajuste",
  "preset.delete": "Eliminar",
  "preset.deleteConfirm": "Eliminar preajuste?",
  "preset.deleteDescription": "El preajuste \"{name}\" sera eliminado permanentemente.",
  "preset.deleteFailed": "Error al eliminar el preajuste",
  "preset.deleted": "Preajuste eliminado",
  "preset.filters": "filtros",
  "preset.filtersWillBeSaved": "filtros seran guardados",
  "preset.maxReached": "Maximo alcanzado",
  "preset.name": "Nombre del preajuste",
  "preset.namePlaceholder": "ej. Peliculas FSC > 100mm",
  "preset.nameRequired": "Ingrese un nombre de preajuste",
  "preset.newName": "Nuevo nombre",
  "preset.noFiltersToSave": "No hay filtros activos para guardar",
  "preset.noPresets": "Sin preajustes guardados",
  "preset.presets": "Preajustes",
  "preset.rename": "Renombrar",
  "preset.renameFailed": "Error al renombrar el preajuste",
  "preset.renamePreset": "Renombrar preajuste",
  "preset.renamed": "Preajuste renombrado",
  "preset.saveCurrentFilters": "Guardar filtros actuales",
  "preset.saveDescription": "Nombre su combinacion de filtros para aplicarla rapidamente despues.",
  "preset.saveFailed": "Error al guardar el preajuste",
  "preset.saveHint": "Aplique filtros y guardelos",
  "preset.savePreset": "Guardar preajuste de filtro",
  "preset.saved": "Preajuste guardado",
  "preset.used": "preajustes usados",
  "scenario.applyChanges": "Aplicar cambios",
  "scenario.autoApproved": "Auto-aprobado",
  "scenario.blocked": "Bloqueado",
  "scenario.currentSettings": "Ajustes actuales",
  "scenario.docsBlocked": "Docs bloqueados",
  "scenario.enabled": "Habilitado",
  "scenario.escalatedRequests": "Solicitudes escaladas",
  "scenario.externalAccess": "Acceso externo",
  "scenario.internalWindow": "En ventana interna",
  "scenario.itemsAtRisk": "Articulos en riesgo",
  "scenario.noChanges": "Ajuste la configuracion y haga clic en 'Vista previa' para ver el efecto",
  "scenario.pendingRequests": "Solicitudes pendientes",
  "scenario.preview": "Vista previa del impacto",
  "scenario.previewResult": "Impacto proyectado",
  "scenario.subtitle": "Vista previa del impacto de cambios de gobernanza antes de aplicarlos",
  "scenario.title": "Analisis What-If de escenarios",
  "scenario.valueAtRisk": "Valor en riesgo",
  "scenario.whatIf": "Vista previa What-If",
  "search.allMaterials": "Todos los materiales",
  "search.filtering": "Filtrando...",
  "search.materialsFound": "materiales encontrados",
  "search.resultsFor": "Resultados para",
  "search.tryAdjusting": "Intente ajustar sus filtros o terminos de busqueda",
  "sort.newestFirst": "Mas recientes primero",
  "sort.oldestFirst": "Mas antiguos primero",
  "sort.priceHighLow": "Precio: Alto a Bajo",
  "sort.priceLowHigh": "Precio: Bajo a Alto",
  "sort.quantityHighLow": "Cantidad: Alto a Bajo",
  "sort.sortBy": "Ordenar por",
  "status.archived": "Archivado",
  "status.pendingApproval": "Aprobacion pendiente",
  "admin.guideAuditSteps": ["Navegue a Admin > Registro de auditoria.", "Use el filtro de tipo de entidad.", "Use el filtro de accion.", "Expanda los 'Cambios' para ver datos modificados.", "Use la paginacion para navegar el historial."],
  "admin.guideCategoriesSteps": ["Navegue a Admin > Categorias para ver el arbol.", "Haga clic en 'Agregar categoria' para una categoria principal.", "Haga clic en '+' en cualquier categoria para agregar una subcategoria.", "Edite o elimine categorias existentes con los botones de accion.", "Las categorias se pueden reordenar con el campo de orden."],
  "admin.guideDashboardSteps": ["Navegue al Dashboard.", "Revise los KPIs globales.", "Use el filtro de sitio para metricas especificas.", "Descargue informes PDF de sostenibilidad.", "Monitoree materiales en riesgo."],
  "admin.guideExternalSteps": ["Las empresas externas se registran via el formulario publico (/register-external).", "Navegue a Admin > Empresas externas para revisar solicitudes pendientes.", "Haga clic en 'Aprobar' para activar la empresa.", "Haga clic en 'Rechazar' para denegar el acceso.", "Las empresas aprobadas pueden listar sus materiales.", "Haga clic en una fila de empresa para ver usuarios vinculados."],
  "admin.guideGettingStartedSteps": ["Cree su grupo empresarial y al menos un sitio en Admin > Organizaciones y Sitios.", "Cargue datos iniciales con el boton 'Cargar datos' (solo una vez para demo/prueba).", "Invite usuarios compartiendo el enlace de registro. Apruebe nuevos usuarios en Admin > Usuarios.", "Configure su modo de gobernanza preferido en Admin > Escenarios.", "Cargue materiales a traves de la pagina de importacion o creelos individualmente."],
  "admin.guideImportSteps": ["Navegue a la pagina de importacion.", "Descargue la plantilla Excel.", "Complete sus datos de materiales y cargue el archivo.", "Revise los resultados de validacion.", "Elija un modo de importacion.", "Ejecute la importacion."],
  "admin.guideNotificationsSteps": ["Navegue a Admin > Notificaciones.", "Revise estadisticas: total enviado, fallido y por tipo.", "Haga clic en 'Verificar ahora' para ejecutar la verificacion de escalacion.", "Explore el historial de notificaciones.", "Las notificaciones requieren una clave API de Resend configurada."],
  "admin.guideScenariosSteps": ["Seleccione un modo: Equilibrado (predeterminado), Conservador, Agresivo (Cash) o Modo Crisis.", "Ajuste la 'Ventana interna' (dias que los materiales permanecen solo internos).", "Configure los 'Dias de escalacion' para notificaciones automaticas.", "Active/desactive 'Externo habilitado' para controlar el acceso externo.", "Active/desactive 'Aprobacion requerida' para aprobacion automatica o manual.", "Active 'Documentacion estricta' para bloquear articulos sin fichas tecnicas."],
  "admin.guideUsersSteps": ["Navegue a Admin > Usuarios para ver todos los registrados.", "Los usuarios pendientes estan marcados con un indicador amarillo.", "Haga clic en 'Aprobar' para conceder acceso completo al mercado.", "Haga clic en 'Revocar' para desactivar temporalmente el acceso.", "Los administradores se aprueban automaticamente al registrarse."],
  "admin.pendingRequests": "Solicitudes pendientes",
  "app.subtitle": "hacer util el excedente",
  "auth.loginError": "Correo o contrasena invalidos",
  "auth.loginSuccess": "Inicio de sesion exitoso!",
  "auth.passwordTooShort": "La contrasena debe tener al menos 6 caracteres",
  "auth.passwordsNoMatch": "Las contrasenas no coinciden",
  "auth.registerError": "Error en el registro",
  "filter.allCategories": "Todas las categorías",
  "home.loginRequired": "Inicie sesion para usar la lista de seguimiento",
  "home.materialsCount": "materiales",
  "home.noMaterials": "No se encontraron materiales.",
  "home.seedDescription": "Puede cargar datos de ejemplo para comenzar.",
  "home.seedError": "Error al cargar los datos",
  "home.seedSuccess": "Datos cargados exitosamente! Actualizando...",
  "home.seeding": "Cargando...",
  "home.watchlistError": "Error al actualizar la lista de seguimiento",
  "sort.dateAdded": "Fecha de alta",
  "sort.price": "Precio",
  "sort.quantity": "Cantidad",
  "admin.platformSettings": "Configuración",
  "admin.resendEmail": "Reenviar correo",
  "guide.title": "Ayuda y preguntas frecuentes",
  "guide.subtitle": "Manual de usuario y respuestas a preguntas frecuentes",
  "guide.searchPlaceholder": "Buscar en el manual y FAQ...",
  "guide.tabGuide": "Manual de usuario",
  "guide.tabFaq": "FAQ",
  "guide.noResults": "Sin resultados para",
  "guide.topic": "tema",
  "guide.topics": "temas",
  "home.hero.badge": "B2B Circular · Impresión y Embalaje",
  "home.hero.verified": "Verificado UE",
  "home.hero.headlineA": "Reutilizar.",
  "home.hero.headlineB": "Reparar.",
  "home.hero.headlineC": "Redistribuir.",
  "home.hero.subtitle": "Surplify es el mercado B2B circular para la industria de la impresión y el embalaje, dando una segunda vida a materiales excedentes, repuestos y máquinas usadas. Cada transacción evita producción virgen, ahorra CO₂ y preserva el capital circulante.",
  "home.hero.impactPrefix": "Ahorrado juntos hasta ahora:",
  "home.hero.impactSuffix": "de CO₂",
  "home.hero.searchPlaceholder": "Fabricante, nº de pieza, material, modelo…",
  "home.hero.searchBtn": "Buscar",
  "home.hero.verticalMaterials": "Excedente",
  "home.hero.verticalSpareParts": "Repuestos",
  "home.hero.verticalMachines": "Máquinas",
  "home.hero.verticalPaints": "Tintas y recubrimientos",
  "home.hero.ctaPostWanted": "Publicar solicitud de compra",
  "home.hero.ctaForSellers": "Para vendedores",
  "home.hero.ctaGuide": "Ayuda y guía",
  "home.hero.trustVies": "IVA verificado por EU VIES",
  "home.hero.trustCompanies": "Cuentas de empresa verificadas",
  "home.hero.trustCircular": "Economía circular",
  "home.newco.badge": "¿Nuevo en Surplify?",
  "home.newco.title": "Tu empresa en el marketplace B2B en 3 pasos",
  "home.newco.subtitle": "Material excedente, residuos, pinturas, repuestos y máquinas de impresión usadas — todo en una sola plataforma. Empieza gratis, comercia de forma justa y documenta conforme a REACH/CLP.",
  "home.newco.step1Title": "Crea tu empresa",
  "home.newco.step1Desc": "Nombre de la empresa, NIF-IVA, dirección — validado con VIES",
  "home.newco.step2Title": "Crea tu primer anuncio",
  "home.newco.step2Desc": "Material, pintura, repuesto o máquina — rellena el formulario, listo",
  "home.newco.step3Title": "Recibe solicitudes y vende",
  "home.newco.step3Desc": "Comisión solo en transacciones exitosas. Sin tarifas de configuración.",
  "home.newco.ctaRegister": "Registra tu empresa ahora",
  "home.newco.ctaPartners": "Para socios y grandes cuentas",
  "home.newco.disclaimer": "Plan inicial gratuito · No se requiere tarjeta de crédito · Conforme con RGPD y B2B",
  "home.newco.whatYouGet": "Lo que obtienes",
  "home.newco.freeTier": "En el plan inicial gratuito",
  "home.newco.feat1Label": "4 verticales de material",
  "home.newco.feat1Sub": "Materiales · Pinturas · Repuestos · Máquinas",
  "home.newco.feat2Label": "Anuncios ilimitados",
  "home.newco.feat2Sub": "Sin límites de cantidad en el plan estándar",
  "home.newco.feat3Label": "Algoritmo de coincidencia",
  "home.newco.feat3Sub": "Las solicitudes de compradores se asignan automáticamente",
  "home.newco.feat4Label": "Cumplimiento REACH/CLP",
  "home.newco.feat4Sub": "Fichas de datos de seguridad y pictogramas GHS integrados",
  "home.newco.feat5Label": "Informes de sostenibilidad",
  "home.newco.feat5Sub": "El ahorro de CO₂ se documenta automáticamente",
  "home.newco.freeBadge": "Empieza 100% gratis",
  "home.pillar.materials.label": "Excedente",
  "home.pillar.materials.title": "Excedente y materiales",
  "home.pillar.materials.desc": "Películas, papel, bobinas y semielaborados — mantenidos en el circuito en lugar de incinerados.",
  "home.pillar.materials.metric": "anuncios activos",
  "home.pillar.spareParts.label": "Repuestos",
  "home.pillar.spareParts.title": "Repuestos y módulos",
  "home.pillar.spareParts.desc": "Piezas OEM reutilizadas — cada componente salvado evita una nueva extracción y producción.",
  "home.pillar.spareParts.metric": "nuevos",
  "home.pillar.machines.label": "Máquinas",
  "home.pillar.machines.title": "Máquinas de impresión",
  "home.pillar.machines.desc": "Las prensas usadas sustituyen a las nuevas — hasta un 80 % menos de CO₂ que comprar nuevas.",
  "home.pillar.machines.metric": "disponibles",
  "home.pillar.paints.label": "Tintas y recubrimientos",
  "home.pillar.paints.title": "Tintas, barnices y aditivos",
  "home.pillar.paints.desc": "Tintas, barnices y aditivos químicos excedentes — mantenidos en producción en vez de tratados como residuo peligroso.",
  "home.pillar.paints.metric": "en stock",
  "home.sustain.liveImpact": "Impacto en vivo",
  "home.sustain.co2": "CO₂ ahorrado",
  "home.sustain.redistributed": "redistribuido",
  "home.sustain.sites": "sedes",
  "home.sustain.circular": "tasa circular",
  "home.sustain.atRisk": "en riesgo",
  "home.machines.label": "Vertical · Máquinas",
  "home.machines.title": "Máquinas de impresión usadas, con un segundo ciclo de producción.",
  "home.machines.subtitle": "Cada prensa usada sustituye a una recién fabricada — con una fracción del CO₂ y materias primas incorporadas. Inspección opcional, compatibilidad verificada.",
  "home.machines.seeAll": "Todas las máquinas",
  "home.machines.emptyDesc": "Aún no hay máquinas de impresión publicadas.",
  "home.machines.emptyCreate": "Crear anuncio",
  "home.spareParts.label": "Vertical · Repuestos",
  "home.spareParts.title": "Repuestos OEM — mantenidos en circulación.",
  "home.spareParts.subtitle": "Stock no usado, búferes de obsolescencia, líneas desmanteladas. Redirigimos las piezas a la producción en lugar de al desguace.",
  "home.spareParts.seeAll": "Todos los repuestos",
  "home.spareParts.emptyDesc": "Aún no hay repuestos publicados.",
  "home.spareParts.emptyCreate": "Crear primer anuncio",
  "home.paints.label": "Vertical · Tintas y recubrimientos",
  "home.paints.title": "Tintas, barnices y aditivos excedentes — de vuelta a la prensa.",
  "home.paints.subtitle": "Tonos descatalogados, lotes sobrantes, stock retirado. Devolvemos los productos químicos de impresión a la producción en lugar de pagar tasas de eliminación.",
  "home.paints.seeAll": "Todas las tintas y recubrimientos",
  "home.paints.emptyDesc": "Aún no hay tintas, barnices o aditivos publicados.",
  "home.paints.emptyCreate": "Crear primer anuncio",
  "home.materials.label": "Vertical · Excedente",
  "home.materials.title": "Excedente y sobreproducción.",
  "home.materials.subtitle": "Stock en directo de tiradas de producción, vaciados de almacén y devoluciones de calidad — devuelto directamente a la industria.",
  "home.trust.vies.title": "IVA UE VIES",
  "home.trust.vies.desc": "Verificación automática del número de IVA para cada empresa registrada.",
  "home.trust.companies.title": "Empresas verificadas",
  "home.trust.companies.desc": "Solo las cuentas B2B examinadas obtienen acceso completo al mercado.",
  "home.trust.csv.title": "Importación CSV masiva",
  "home.trust.csv.desc": "Liste miles de repuestos y materiales en una sola carga.",
  "home.trust.circular.title": "Economía circular",
  "home.trust.circular.desc": "Cada redistribución evita producción virgen y reduce las emisiones de alcance 3.",
  "machine.card.label": "Máquina de impresión",
  "machine.card.year": "Año",
  "machine.card.hours": "h",
  "machine.card.width": "Ancho",
  "machine.card.price": "Precio",
  "sparePart.card.label": "Repuesto",
  "sparePart.card.compatible": "Compatible:",
  "sparePart.card.single": "Unidad"
};

export default es;
